// extracted by mini-css-extract-plugin
module.exports = {"switch-department__message":"switch-department__message__1eSbv"};